import ReactDOM from 'react-dom/client';
import App from './App';

/**
 * Entry point của React application.
 * Tìm container #root trong DOM, nếu không tìm thấy sẽ log warning
 * thay vì throw error để không làm crash trang (trường hợp
 * public/index.html dùng HTML tĩnh độc lập như LadiPage export).
 */
function mountApp() {
  const container = document.getElementById('root');

  if (!container) {
    console.warn(
      '[React] Không tìm thấy phần tử #root trong public/index.html. ' +
        'Bỏ qua mount React app, trang sẽ chạy với HTML tĩnh.'
    );
    return;
  }

  const root = ReactDOM.createRoot(container);
  root.render(<App />);
}

mountApp();
